import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Settlement() {
  return <OperationalResource title="Settlement &amp; Performance" resource="settlement" />;
}
